import { useEffect, useState } from 'react';
import { getCategoryTree, type CategoryTree } from '../lib/api';
import styles from './StartQuizPage.module.css';

interface StartQuizPageProps {
  onStartQuiz: (category?: string, subcategory?: string) => void;
}

export function StartQuizPage({ onStartQuiz }: StartQuizPageProps) {
  const [categories, setCategories] = useState<CategoryTree[]>([]);
  const [expandedCategory, setExpandedCategory] = useState<string | null>(null);

  useEffect(() => {
    getCategoryTree().then(setCategories).catch(console.error);
  }, []);

  return (
    <div className={styles.container}>
      <h1 className={styles.pageTitle}>Start a Quiz</h1>

      {/* Quick Start Card */}
      <div className={styles.quickStartCard}>
        <h2 className={styles.cardTitle}>Quick Start</h2>
        <p className={styles.cardDescription}>
          Take a quiz with questions from all categories. Questions adapt to your skill level.
        </p>
        <button onClick={() => onStartQuiz()} className={styles.primaryButton}>
          Start Random Quiz
        </button>
      </div>

      {/* Categories Section */}
      <div className={styles.categoriesSection}>
        <h2 className={styles.sectionTitle}>Choose a Category</h2>
        <div className={styles.categoriesGrid}>
          {categories.map((cat) => (
            <div key={cat.name} className={styles.categoryGroup}>
              <button
                className={`${styles.categoryCard} ${expandedCategory === cat.name ? styles.expanded : ''}`}
                onClick={() => {
                  if (cat.subcategories.length > 0) {
                    setExpandedCategory(expandedCategory === cat.name ? null : cat.name);
                  } else {
                    onStartQuiz(cat.name);
                  }
                }}
              >
                <span className={styles.categoryName}>
                  {cat.name}
                  {cat.subcategories.length > 0 && (
                    <span className={styles.expandIcon}>
                      {expandedCategory === cat.name ? '▼' : '▶'}
                    </span>
                  )}
                </span>
                <span className={styles.categoryCount}>{cat.count} questions</span>
              </button>

              {/* Subcategories dropdown */}
              {expandedCategory === cat.name && cat.subcategories.length > 0 && (
                <div className={styles.subcategories}>
                  <button
                    className={styles.subcategoryButton}
                    onClick={() => onStartQuiz(cat.name)}
                  >
                    <span>All {cat.name}</span>
                    <span className={styles.subcategoryCount}>{cat.count}</span>
                  </button>
                  {cat.subcategories.map((sub) => (
                    <button
                      key={sub.name}
                      className={styles.subcategoryButton}
                      onClick={() => onStartQuiz(cat.name, sub.name)}
                    >
                      <span>{sub.name}</span>
                      <span className={styles.subcategoryCount}>{sub.count}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
